"use client";


import useFormItemReset, { useFormItemRef_byName } from '@/app/hooks/useFormItemReset';
import { cn } from '@/lib/utils';
import React, { ReactNode, useEffect, useState } from 'react';
import { BsSortDownAlt } from "react-icons/bs";
import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from "./select";

export interface SortByProps {
    options: SortByOption[];
    onChange: (value: string) => void;
    className?: string;
    disabled?: boolean;
    name?: string;
}

export interface SortByOption { label: ReactNode; value: string }

const SortBy: React.FC<SortByProps> = ({ options, onChange, className, disabled, name }) => {
    const [selectedValue, setSelectedValue] = useState<string>();

    function handleSelectChange(value: string) {
        setSelectedValue(value);
        onChange(value);
    };

    //allow form reset to work properly (updates UI correctly)
    const selectRef = useFormItemRef_byName<HTMLSelectElement>(name);
    useFormItemReset(selectRef, () => {
        handleSelectChange("");
    })

    //reset selected value on options change
    useEffect(() => {
        handleSelectChange("")
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [options])

    return (
        <Select onValueChange={ handleSelectChange } value={ selectedValue } disabled={ disabled } name={ name } >
            <SelectTrigger className={ cn('w-auto sm:min-w-fit p-0 px-2', className) } >
                <BsSortDownAlt />
                <div className='hidden sm:block whitespace-nowrap'>
                    <SelectValue placeholder="מיין לפי" />
                </div>
            </SelectTrigger>
            <SelectContent>
                { options.map((option) => (
                    <SelectItem key={ option.value } value={ option.value }>
                        { option.label }
                    </SelectItem>
                )) }
            </SelectContent>
        </Select>
    );
};

export default SortBy;